import AUTH_ROUTES from '@/presentation/modules/auth/constants/routes/index.js';

const authRoutes = [
	{
		name: AUTH_ROUTES.root.name,
		path: AUTH_ROUTES.root.path,
		redirect: AUTH_ROUTES.root.redirect,
		meta: AUTH_ROUTES.root.meta,
		component: AUTH_ROUTES.root.component,
		children: [
			{
				name: AUTH_ROUTES.login.name,
				path: AUTH_ROUTES.login.path,
				component: AUTH_ROUTES.login.component,
			},
			{
				name: AUTH_ROUTES.otp.name,
				path: AUTH_ROUTES.otp.path,
				component: AUTH_ROUTES.otp.component,
			},
			{
				name: AUTH_ROUTES.signup.name,
				path: AUTH_ROUTES.signup.path,
				component: AUTH_ROUTES.signup.component,
			},
			{
				name: AUTH_ROUTES.adminLogin.name,
				path: AUTH_ROUTES.adminLogin.path,
				component: AUTH_ROUTES.adminLogin.component,
			},
			{
				name: AUTH_ROUTES.adminOtp.name,
				path: AUTH_ROUTES.adminOtp.path,
				component: AUTH_ROUTES.adminOtp.component,
			},
			{
				name: AUTH_ROUTES.adminTotp.name,
				path: AUTH_ROUTES.adminTotp.path,
				component: AUTH_ROUTES.adminTotp.component,
			},
		],
	},
];

export default authRoutes;
